export default __webpack_public_path__ + "9d8b9393006f6dbf7adc824d6e606f9d.svg";